import { Iris, Iri } from '@/rec-cache/rec-cache-types'

// TODO introduce common parent class with RecIndividual. Define in same module as RecIndividual.
// TODO organize in metadata, data properties (properties), object properties (relationships), components.
class RecComponent {
  constructor(namespaces = null) {
    this._id = new Iri()
    this.types = []
    this.properties = []
    this.namespaces = namespaces
  }
  get id() {
    return this._id
  }

  set id(value) {
    this._id = value instanceof Iri ? value : new Iri(value, this.namespaces)
  }

  get type() {
    // Returns first non named individual IRI from types array. As such doesnt support multi inheritance.
    // TODO check if type will be undefined if filtered array is empty?
    const [type] = this.types.filter((t) => t.value != Iris.owlNamedIndividual)
    return type
  }

  // Parameter name is Iri or value string. Returns array of Value, or undefined if name is not found.
  getValuesByName(name) {
    const nameValue = name instanceof Iri ? name.value : name
    return this.properties.find((p) => p.name.value == nameValue)?.values
  }
}

export { RecComponent }
